import React from 'react';

/**
 * Giriş Adresleri çekmecesinin anlatımı: alan adı nasıl eklenir, engellenince
 * nasıl değiştirilir, eskisi nasıl kapatılır.
 *
 * Kılavuzun bölümü (`admin_guide.html#giris-adresleri`) ekranın her düğmesini
 * ve teknik ayrıntısını anlatır; burası yöneticinin o an yapacağı işin kısa
 * yoludur ve ekrandaki düğme adlarıyla konuşur. Düğme adı değişirse burası da
 * değişir. Ayrıntı için çekmecenin altındaki "Kılavuzun tamamını aç" durur.
 */
const EntryDomainsGuide = () => (
  <div className="admin-help-guide">
    <section>
      <h3>Önce mantığı</h3>
      <p>
        Site aynı anda birden çok alan adıyla çalışabilir ama bunlardan
        yalnızca <b>biri yayındadır</b>. Listedeki diğer adreslere gelen
        oyuncu, siteyi orada görmez; kendiliğinden yayındaki adrese taşınır.
      </p>
      <p>
        Yani bir adres engellendiğinde yapmanız gereken tek şey, önceden
        hazırladığınız yedeği yayına almaktır. Oyuncunun elindeki eski
        bağlantılar da yeni adrese götürür.
      </p>
    </section>

    <section>
      <h3>Yeni alan adı eklemek</h3>
      <ol>
        <li>
          Alan adının DNS kaydını (A kaydı) sitenin sunucusuna yönlendirin.
          Kayıt yayılmadan adres açılmaz ve sertifika alınamaz; bu birkaç
          dakika ile birkaç saat sürebilir.
        </li>
        <li>
          <b>Adres listesi</b> kartında alan adını yazın
          (ör. <code>site302.com</code>, başında <code>https://</code> olmadan),
          türü <b>Giriş adresi</b> bırakın ve <b>Ekle</b>&apos;ye basın.
        </li>
        <li>
          Adresin yanındaki <b>Sunucuya kur</b> düğmesine basın. Panel, sitenin
          çalışan ayarını yeni adrese kopyalar ve sertifikayı alır; çalışan
          adreslere dokunmaz. Sertifika alınamadıysa DNS yayıldıktan sonra
          <b> SSL al</b>&apos;a basın.
          <span className="admin-help-note">
            Bu düğme için <b>Sunucu bağlantısı</b> kartı bir kez doldurulmuş
            olmalıdır. Doldurmak istemiyorsanız adresi sunucuda teknik ekibiniz
            kurar; ekranın geri kalanı aynı çalışır.
          </span>
        </li>
        <li>
          <b>Kontrol et</b>&apos;e basın. Satırın altında
          &quot;Kuruluma çözüyor&quot; yazıyorsa adres hazırdır.
        </li>
        <li>
          Burada durun. Adres artık <b>hazır yedektir</b>; yayına almanız
          gerekmez, ihtiyaç anına kadar listede bekler.
        </li>
      </ol>
    </section>

    <section>
      <h3>Adres engellenince değiştirmek</h3>
      <ol>
        <li>
          Listeden hazır bir yedek seçin ve önce <b>Kontrol et</b> ile hâlâ
          açıldığından emin olun.
        </li>
        <li>
          <b>Yayına al</b>&apos;a basın. Bu kadar: eski adres kendiliğinden
          &quot;engellendi&quot; olarak işaretlenir. Oraya gelen oyuncu yeni
          adrese taşınmaz, &quot;bu adres artık kullanılmıyor&quot; ekranını
          görür — engellenen adres yeni adresi ele vermez.
        </li>
        <li>
          Footer&apos;daki adres duyurusu, Hızlı Giriş ve (lisans giriş
          adreslerine bağlıysa) lisans kendiliğinden güncellenir. Sizin elle
          yazdığınız yerleri — Telegram kanalı, SMS, sosyal medya, reklam
          metni — yeni adresle siz güncelleyin.
        </li>
        <li>
          Hemen bir sonraki yedeği ekleyin. Elinizde hazır yedek yokken
          gelen ikinci engel siteyi bekletir.
        </li>
      </ol>
    </section>

    <section>
      <h3>Eski adresi kapatmak</h3>
      <p>
        Engellenen adres listede kalabilir; zararı yoktur, oyuncuyu yine yeni
        adrese taşır. Artık tamamen kullanılmasın istiyorsanız:
      </p>
      <ul>
        <li>
          <b>Sunucudan kaldır</b> — adres sunucuda kapanır, hiçbir sayfa
          açmaz. Listede &quot;kapatıldı&quot; olarak kalır.
        </li>
        <li>
          <b>Sil</b> — adresi listeden çıkarır; onay penceresinde sunucudan
          da kaldırmayı seçebilirsiniz.
        </li>
      </ul>
      <p className="admin-help-note">
        Yayındaki adres ve şu anda paneli açtığınız adres kapatılamaz.
      </p>
    </section>

    <section>
      <h3>Hızlı Giriş nedir?</h3>
      <p>
        Oyunculara bir kez duyurduğunuz ve <b>hiç değişmeyen</b> bir alan
        adıdır. Kendisi site açmaz; her ziyaretçiyi o an yayındaki adrese
        gönderir. Yayındaki adresi değiştirdiğinizde ona dokunmanız gerekmez.
        Eklemek için türü <b>Hızlı Giriş</b> seçin; yalnızca bir tane olabilir.
      </p>
    </section>

    <section>
      <h3>Bu ekran neye dokunmaz?</h3>
      <p>
        Panel, bildirim ve lisans adresleri (<b>Alan Adları</b> ekranı) burada
        yapılan hiçbir işlemden etkilenmez. Paneli giriş adreslerinden biriyle
        açıyorsanız da adres değişirken panelden atılmazsınız.
      </p>
    </section>
  </div>
);

export default EntryDomainsGuide;
